import DaysReading from './DaysReading';

export default DaysReading;
